import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { css } from "@emotion/react";
import { useIsPC } from "../../hooks";

const MvtkWidget = () => {
  const widgetRef = useRef(null);

  const isPC = useIsPC();
  const dataFormat = useMemo(() => (isPC ? "horizontal" : "vertical"), [isPC]);

  useEffect(() => {
    // scriptタグのIDまたは他の識別子によって特定のscriptタグを選択
    const script = document.createElement("script");
    script.src =
      "https://contents.mvtk.jp/widgets/js/widgets_v1_1.js?time=" +
      new Date().getTime();
    script.async = true;

    script.onload = () => {
      // console.log("script loaded");
      // スクリプトがロードされたら状態を更新
    };

    document.body.appendChild(script);

    // コンポーネントのクリーンアップ時にスクリプトを削除
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div css={widgetWrapperStyle}>
        <div
          ref={widgetRef}
          id="mvtk-widgets-container"
          data-format={dataFormat}
          data-color="normal"
        >
          <a
            id="mvtk-widgets"
            href="https://mvtk.jp/Film/085563"
            target="_blank"
            rel="noopener noreferrer"
          >
            Widgets by ムビチケ
          </a>
        </div>
      </div>
    </>
  );
};

const widgetWrapperStyle = css`
  margin-top: 5px;
`;

export default MvtkWidget;
